import { createAsyncThunk } from '@reduxjs/toolkit';
import { EApiStatuses } from '../../../constants';
import {IError, IPageActionsPayload} from '../../../models/inner-models';
import {IDownloadZip, IRestorePayload} from '../../../models/models';
import { EBackups, EPlatformNames } from '../../constants';
import { addPlatformIdentifier } from '../../functions';
import instance from '../../middlewares/api';

const getGithubActions = createAsyncThunk(
  addPlatformIdentifier(EBackups.transferRepoData, EPlatformNames.github),
  async (payload: IPageActionsPayload, thunkAPI) => {
    try {
      const response = await instance.post(`user/get-actions?page=${payload.page}&perPage=${payload.perPage}`,
        {platform: EPlatformNames.github, id: payload.itemId});

      return (!response?.data?.result || response.data.status !== EApiStatuses.SUCCESS) ?
        thunkAPI.rejectWithValue({ error: response?.data?.message || 'Error on data load. Try later' }) : response.data.result;
    } catch (err) {
      const error = err as IError

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  },
);

const restoreGithubBackup = createAsyncThunk(
  addPlatformIdentifier(EBackups.restoreBackup, EPlatformNames.github),
  async (repoRestore: IRestorePayload, thunkAPI) => {
    try {
      const resp = await instance.post('github/restore-repos', repoRestore);
      return (!resp?.data || resp.data.status !== EApiStatuses.SUCCESS) ?
        thunkAPI.rejectWithValue({ error: resp?.data?.message || 'Error on data restore. Try later' }) : resp.data;
    } catch (err) {
      const error = err as IError

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  },
);
const restoreGithubGistBackup = createAsyncThunk(
  addPlatformIdentifier(EBackups.restoreBackupGist, EPlatformNames.github),
  async (repoRestore: IRestorePayload, thunkAPI) => {
    try {
      const resp = await instance.post('github/restore-gists', repoRestore);
      return (!resp?.data || resp.data.status !== EApiStatuses.SUCCESS) ?
        thunkAPI.rejectWithValue({ error: resp?.data?.message || 'Error on data restore. Try later' }) : resp.data;
    } catch (err) {
      const error = err as IError

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  },
);

const downloadGithubZip = createAsyncThunk(
  addPlatformIdentifier(EBackups.downloadZip, EPlatformNames.github),
  async (repoRestore: IDownloadZip, thunkAPI) => {
    try {
      const resp = await instance.post('github/github-get-zip', repoRestore);
      return (!resp?.data?.result || resp.data.status !== EApiStatuses.SUCCESS) ?
        thunkAPI.rejectWithValue({message: resp?.data?.message, status: resp?.data?.status}) : resp.data.result;
    } catch (err) {
      const error = err as IError

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  },
);


const downloadGithubGistZip = createAsyncThunk(
  addPlatformIdentifier(EBackups.downloadGistZip, EPlatformNames.github),
  async (repoRestore: IDownloadZip, thunkAPI) => {
    try {
      const resp = await instance.post('github/github-gist-get-zip', repoRestore);
      return (!resp?.data?.result || resp.data.status !== EApiStatuses.SUCCESS) ?
        thunkAPI.rejectWithValue({message: resp?.data?.message, status: resp?.data?.status}) : resp.data.result;
    } catch (err) {
      const error = err as IError

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  },
);

export { getGithubActions, restoreGithubBackup, restoreGithubGistBackup, downloadGithubZip, downloadGithubGistZip };
